import React, { FC } from 'react';
import { FuelEfficiency } from './FuelEfficiency/FuelEfficiency';

export const FuelEfficiencyPage: FC = () => {
  return <FuelEfficiency />;
};
